import { FormikProps, useFormik } from "formik";
import { KYCFormProps } from "../types/kyc-form";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useNavigate } from "react-router";
import { RootState } from "store";

const useKYCScreen = () => {
  const [showOtpDialog, setShowOtpDialog] = useState<boolean>(false);
  const navigate = useNavigate();
  const adharDetails: any = useSelector(
    (state: RootState) => state.hostForm.hostKYC
  );

  const closeOtpDialog = () => {
    setShowOtpDialog(false);
  };

  const openOtpDialog = () => {
    setShowOtpDialog(true);
  };

  const formik: FormikProps<KYCFormProps> =
    useFormik<KYCFormProps>({
      initialValues: {
        adharNumber: adharDetails?.maskedAadhaarNumber || "",
        confirmadharNumber: adharDetails?.maskedAadhaarNumber || "",
        fullName: adharDetails?.name || "",
        dateofbirth: adharDetails?.dob || "",
        address: adharDetails?.address || "",
        pincode: adharDetails?.pincode || "",
        district: adharDetails?.splitAddress?.dist || "",
        state: adharDetails?.splitAddress?.state || "",
        city:  adharDetails?.splitAddress?.vtc || "",
        panNumber: adharDetails?.panNumber || "",
      },
      validationSchema: Yup.object({
        adharNumber: Yup.string()
          .required("Aadhaar Number is required")
          .matches(/^\d{12}$/, "Aadhaar Number must be 12 digits"),
        confirmadharNumber: Yup.string()
        .required("Confirm Aadhaar Number is required")
        .oneOf(
            [Yup.ref("adharNumber")],
            "Aadhaar Number and Confirm Aadhaar Number must match"
          ),
        panNumber: Yup.string().required("PAN Number is required"),
      }),
      enableReinitialize: true,
      onSubmit: (values) => {
        navigate("/profile-details");
      },
    });
  return { formik, closeOtpDialog, openOtpDialog, showOtpDialog };
};

export default useKYCScreen;
